import React, { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { createItems, getAllItems } from "../../actions/itemActions";
import { useNavigate } from "react-router-dom";
import { getAllCategories } from "../../actions/categories";
import { getAllSubCategories } from "../../actions/subCategories";
import { getAllStores } from "../../actions/storeActions";
import defaultPic from "../../assets/img/dummy.jpeg";
import AWS from "aws-sdk";
import axios from "axios";
import {
  BUCKET_ACCESS_KEY_ID,
  BUCKET_BASE_URL,
  BUCKET_ENDPOINT,
  BUCKET_NAME,
  BUCKET_REGION,
  BUCKET_SECRET_KEY,
  SERVERADDRESS,
} from "../../../src/constants";

const S3_BUCKET = BUCKET_NAME;
// const REGION ='YOUR_DESIRED_REGION_HERE';

AWS.config.update({
  accessKeyId: BUCKET_ACCESS_KEY_ID,
  secretAccessKey: BUCKET_SECRET_KEY,
});
const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: BUCKET_REGION,
  endpoint: BUCKET_ENDPOINT,
  // region: REGION,
});

const StoreAdminCreateItemsModal = () => {
  const store = useSelector((state) => state.store);
  const items = useSelector((state) => state.items);
  const auth = useSelector((state) => state.auth);
  const categories = useSelector((state) => state.categories);
  const subCategories = useSelector((state) => state.subCategories);
  const [progress, setProgress] = useState(0);
  const [awsURL, setAwsURL] = useState(null);
  const [selectedImage, setSelectedImage] = useState(defaultPic);
  const [profileData, setProfileData] = useState({});

  const dispatch = useDispatch();
  const orderData = async (e) => {
    dispatch(getAllStores());
  };
  useEffect(() => {
    orderData();
  }, []);
  const navigate = useNavigate();
  const [values, setValues] = useState({
    userId: auth.user.id,
    storeId: "",
    categoryId: "",
    subCategoryId: "",
    name: "",
    sellPrice: "",
    realPrice: "",
    discount: "",
    expiryDate: "",
    status: "",
    stock: "",
    // kind: Joi.string(),
    measuringUnit: "",
    descriptions: "",
    keyFeatures: "",
    disclaimer: "",
    coverImg: "",
    itemPic: "",
    // coverImg: "",
    // img: "",
  });
  console.log(values, "values");
  const handleChange = (fieldName) => (event) => {
    setValues({
      ...values,
      [fieldName]: event.target.value,
    });
  };

  const storeData = {
    // userId: auth.user.id,
    // storeId: values.categoryId,
    storeId: values.storeId,
    categoryId: values.categoryId,
    subCategoryId: values.subCategoryId,
    name: values.name,
    sellPrice: values.sellPrice,
    realPrice: values.realPrice,
    discount: values.discount,
    expiryDate: values.expiryDate,
    status: values.status ? values.status : true,
    stock: values.stock,
    // kind: Joi.string(),
    measuringUnit: values.measuringUnit,
    descriptions: values.descriptions,
    keyFeatures: values.keyFeatures,
    disclaimer: values.disclaimer,
    coverImg: values.coverImg,
    itemPic: values.itemPic,
    // coverImg: "",
    // img: "",
  };
  console.log(storeData, "storeData");

  const cb = () => {
    // console.log("cbbbbb", cb);
    dispatch(getAllItems(navigateItems));
    // openAddModal();
    setValues({
      // userId: auth.user.id,
      //   storeId: "",
      categoryId: "",
      subCategoryId: "",
      name: "",
      sellPrice: "",
      realPrice: "",
      discount: "",
      expiryDate: "",
      status: "",
      stock: "",
      // kind: Joi.string(),
      measuringUnit: "",
      descriptions: "",
      keyFeatures: "",
      coverImg: "",
      itemPic: "",
      // coverImg: "",
      // img: "",
    });
  };

  const filteredSubCategories = subCategories?.subCategories?.filter(
    (subCategory) => subCategory?.categoryId === values.categoryId
  );

  const catData = async (e) => {
    dispatch(getAllCategories({}));
  };
  const subData = async (e) => {
    dispatch(getAllSubCategories({}));
  };

  const navigateItems = () => {
    // navigate("/requested-orders");
    navigate("/products");
  };

  const handleChangePic = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Display the selected image immediately
    const tempUrl = URL.createObjectURL(file);
    setSelectedImage(tempUrl);

    console.log("Uploading file...");
    // console.log("cccccccccccccccc");

    const today = new Date();
    const date = today.getTime();
    const params = {
      Bucket: S3_BUCKET,
      //   Key:
      //     "data/" +
      //     "SuperAdminData" +
      //     "/ProfilePic/" +
      //     date +
      //     "/" +
      //     event.target.files[0].name,
      //   Body: event.target.files[0],
      Key: `data/SuperAdminData/ProfilePic/${date}/${file.name}`,
      Body: file,
      ACL: "public-read",
    };
    var upload = myBucket
      .upload(params)
      .on("httpUploadProgress", (evt) => {
        setProgress(Math.round((evt.loaded / evt.total) * 100));
      })
      .promise();
    let url;
    await upload.then(function (data, err) {
      try {
        url = BUCKET_BASE_URL + data.Key;
        setAwsURL(url);
        console.log(url, "url");
      } catch (error) {
        // console.log(error, err, "ee");
      }
      console.log(upload, "upload");
    });

    const { data } = await axios.post(
      `${SERVERADDRESS}/v1/fileupload/profilePicUpload`,
      {
        // url: url,
        // file: event.target.files[0].name,
        // type: event.target.files[0].type,
        url: url,
        file: file.name,
        type: file.type,
        // userId: auth.user.id,
        // companyId: auth.user.companyId.id,
      }
    );
    // setSelectedImage(url);
    setValues({
      ...values,
      ["itemPic"]: data.id,
    });
    // dispatch(createUser({ userId: auth.user.id, profilePic: data.id }));
    console.log(data, "data");
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("first");
    for (let key of Object.keys(storeData)) {
      if (storeData[key] === "") {
        delete storeData[key];
      }
    }
    dispatch(createItems(storeData, cb));
  };
  useEffect(() => {
    catData();
    subData();
  }, []);
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Create Product</h5>
                      </div>
                    </div>
                  </div>
                  <div className="container">
                    <form onSubmit={handleSubmit}>
                      <fieldset>
                        <legend>PRODUCT DETAILS</legend>
                        <div className="row">
                          {auth.user.role === "superAdmin" && (
                            <>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="ShopName">Select Shop</label>
                                  <select
                                    className="form-select"
                                    id="ShopName"
                                    value={values.storeId} // Bind the selected value
                                    onChange={handleChange("storeId")} // Handle selection changes
                                  >
                                    <option value="">Select Shop</option>
                                    {store?.store?.map((s) => (
                                      <option key={s?.id} value={s?.id}>
                                        {s?.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-6"></div>
                            </>
                          )}

                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="CategoryName">
                                Select Category
                              </label>
                              <select
                                className="form-select"
                                id="CategoryName"
                                value={values.categoryId} // Bind the selected value
                                onChange={handleChange("categoryId")} // Handle selection changes
                              >
                                <option value="">Select Category</option>
                                {categories?.categories?.map((category) => (
                                  <option
                                    key={category?.id}
                                    value={category?.id}
                                  >
                                    {category?.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="gender">
                                Select Sub Category
                              </label>
                              <select
                                className="form-select"
                                id="subCategoryName"
                                disabled={!values.categoryId}
                                value={values.subCategoryId} // Bind the selected value
                                onChange={handleChange("subCategoryId")} // Handle selection changes
                              >
                                <option value="">Select Category</option>
                                {/* {subCategories?.subCategories?.map((x) => (
                                  <option key={x?.id} value={x?.id}>
                                    {x?.name}
                                  </option> */}
                                {filteredSubCategories?.map((x) => (
                                  <option key={x?.id} value={x?.id}>
                                    {x?.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="Name">Name</label>
                              <input
                                type="text"
                                className="form-control"
                                id="Name"
                                placeholder="Name"
                                value={values.name}
                                onChange={handleChange("name")}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="Name">Real Price</label>
                              <input
                                type="text"
                                className="form-control"
                                id="Name"
                                placeholder="Real Price"
                                value={values.realPrice}
                                onChange={handleChange("realPrice")}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="Name">Sell Price</label>
                              <input
                                type="text"
                                className="form-control"
                                id="Name"
                                placeholder="Sell Price"
                                value={values.sellPrice}
                                onChange={handleChange("sellPrice")}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="Name">Discount %</label>
                              <input
                                type="text"
                                className="form-control"
                                // id="discount"
                                placeholder="Discount %"
                                value={values.discount}
                                onChange={handleChange("discount")}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="Name">Exp Date</label>
                              <input
                                type="date"
                                className="form-control"
                                id="Name"
                                // placeholder="Discount %"
                                value={values.expiryDate}
                                onChange={handleChange("expiryDate")}
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="gender">Status</label>
                              <select
                                className="form-select"
                                id="gender"
                                value={values.status}
                                onChange={handleChange("status")}
                              >
                                <option value="0" selected disabled>
                                  Select Status
                                </option>
                                <option value={true}>Available</option>
                                <option value={false}>Hide</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="gender">In Stock</label>
                              <select
                                className="form-select"
                                id="gender"
                                value={values.stock}
                                onChange={handleChange("stock")}
                              >
                                <option value="0" selected disabled>
                                  Select InStock
                                </option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                              </select>
                            </div>
                          </div>
                          {/* <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="gender">Type</label>
                              <select
                                className="form-select"
                                id="gender"
                                value={values.measuringUnit}
                                onChange={handleChange("measuringUnit")}
                              >
                                <option value="0" selected disabled>
                                  Select Gender
                                </option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                              </select>
                            </div>
                          </div> */}
                          {/* <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="gender">Type</label>
                              <select
                                className="form-select"
                                id="gender"
                                //   value={values.gender}
                                //   onChange={handleChange("gender")}
                              >
                                <option value="0" selected disabled>
                                  Select Gender
                                </option>
                                <option value="male">Gram</option>
                                <option value="female">Kg</option>
                                <option value="female">Liter</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="gender">Size</label>
                              <select
                                className="form-select"
                                id="gender"
                                //   value={values.gender}
                                //   onChange={handleChange("gender")}
                              >
                                <option value="0" selected disabled>
                                  Select Gender
                                </option>
                                <option value="male">Gram</option>
                                <option value="female">Kg</option>
                                <option value="female">Liter</option>
                              </select>
                            </div>
                          </div> */}
                        </div>
                      </fieldset>
                      <fieldset>
                        <legend>Description</legend>
                        <div className="row">
                          {/* <div className="col-md-12"> */}
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="storeDesc">
                                Product Description and Picture(s)
                              </label>
                              <textarea
                                className="form-control"
                                id="storeDesc"
                                rows="3"
                                placeholder="Store Description"
                                value={values.descriptions}
                                onChange={handleChange("descriptions")}
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="storeDesc">Key Features</label>
                              <textarea
                                className="form-control"
                                // id="storeDesc"
                                rows="3"
                                placeholder="Key Features"
                                value={values.keyFeatures}
                                onChange={handleChange("keyFeatures")}
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="storeDesc">Disclaimer</label>
                              <textarea
                                className="form-control"
                                // id="storeDesc"
                                rows="3"
                                placeholder="Disclaimer"
                                value={values.disclaimer}
                                onChange={handleChange("disclaimer")}
                              ></textarea>
                            </div>
                          </div>

                          <div className="upload-section">
                            <div className="upload-item">
                              <label for="coverImage">
                                Upload cover image here
                              </label>
                              <input
                                type="file"
                                id="coverImage"
                                accept=".jpg, .jpeg, .png"
                                onChange={handleChangePic}
                              />
                            </div>
                            {selectedImage && (
                              <div className="preview">
                                <img src={selectedImage} alt="Cover Preview" />
                              </div>
                            )}
                            {/* <div className="upload-item">
                              <label for="image1">Upload image 1</label>
                              <input
                                type="file"
                                id="image1"
                                accept=".jpg, .jpeg, .png"
                                onChange={handleChangePic}
                              />
                            </div>
                            {selectedImage && (
                              <div className="preview">
                                <img
                                  src={selectedImage}
                                  alt="Image 1 Preview"
                                />
                              </div>
                            )} */}

                            {/* <div className="upload-item">
                              <label for="image2">Upload image 2</label>
                              <input type="file" id="image2" />
                            </div>
                            <div className="preview">
                              <img src={defaultPic} alt="Image 2 Preview" />
                            </div>
                            <div className="upload-item">
                              <label for="image2">Upload image 3</label>
                              <input type="file" id="image3" />
                            </div>
                            <div className="preview">
                              <img src={defaultPic} alt="Image 2 Preview" />
                            </div> */}
                          </div>
                        </div>
                        {/* </div> */}
                      </fieldset>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                          // onClick={() => openAddModal()}
                        >
                          Add More Pictures
                        </button>
                        <button type="submit" className="btn btn-primary">
                          Save changes
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoreAdminCreateItemsModal;
